var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sid-select"},[_c('div',{staticClass:"w-full mt-[14px] !py-[14px] !px-[16px]"},[(!_vm.staticType)?_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Name")]),_c('div',{staticClass:"w-[118px]"},[_c('b-input',{on:{"input":_vm.changeFieldName},model:{value:(_vm.control.field_name),callback:function ($$v) {_vm.$set(_vm.control, "field_name", $$v)},expression:"control.field_name"}})],1)])]):_vm._e(),(!_vm.staticType)?_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Type")]),_c('div',{staticClass:"w-[118px]"},[_c('v-select',{staticClass:"custom-select",attrs:{"value":_vm.type,"options":_vm.typeOptions,"reduce":item => item.value},on:{"input":function($event){return _vm.selectFieldType($event)}}})],1)])]):_vm._e(),(!_vm.hideLabel)?_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Label")]),_c('div',{staticClass:"w-[118px]"},[_c('b-input',{on:{"input":e => _vm.$emit('changeLabel', e)},model:{value:(_vm.control.label),callback:function ($$v) {_vm.$set(_vm.control, "label", $$v)},expression:"control.label"}})],1)])]):_vm._e(),(!_vm.hidePlaceholder)?[(_vm.isSupportedPlaceholder)?_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Placeholder")]),_c('div',{staticClass:"w-[118px]"},[_c('b-input',{on:{"input":e => _vm.$emit('changePlaceholder', e)},model:{value:(_vm.control.placeholder),callback:function ($$v) {_vm.$set(_vm.control, "placeholder", $$v)},expression:"control.placeholder"}})],1)])]):_c('b-form-group',{attrs:{"label":"Text"}},[_c('b-textarea',{model:{value:(_vm.control.placeholder),callback:function ($$v) {_vm.$set(_vm.control, "placeholder", $$v)},expression:"control.placeholder"}})],1)]:_vm._e(),(!_vm.staticType)?_c('b-row',{staticClass:"align-items-center"},[_c('b-col',[_c('label',{attrs:{"for":"required-mark"}},[_vm._v("Required")])]),_c('b-col',{staticClass:"text-right"},[_c('b-checkbox',{staticClass:"mb-2",attrs:{"id":"required-mark","switch":"","value":true,"unchecked-value":false},model:{value:(_vm.isRequired),callback:function ($$v) {_vm.isRequired=$$v},expression:"isRequired"}})],1)],1):_vm._e(),_c('sid-range-slider',{staticClass:"mt-[12px]",attrs:{"label":"Width","sid":`${_vm.sidClass}`,"dimensions":['%', 'px'],"default-dimension":"%","rule-name":"width","var":"--width","measurement":"width"}})],2),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Label Styles","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('sid-font',{attrs:{"prefix":"Label","sid":`${_vm.sidClass} legend`}}),_c('sid-range-slider',{attrs:{"label":"Label Font Size","sid":`${_vm.sidClass} legend`,"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Label Text Color")]),_c('sid-color',{attrs:{"sid":`${_vm.sidClass} legend`,"rule-name":"color"}})],1)])],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Placeholder Styles","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('sid-font',{attrs:{"prefix":"Placeholder","sid":`${_vm.sidClass} .input.form-control::placeholder`}}),_c('sid-range-slider',{attrs:{"label":"Placeholder Font Size","sid":`${_vm.sidClass} .input.form-control::placeholder`,"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Placeholder Font Color")]),_c('sid-color',{attrs:{"sid":`${_vm.sidClass} .input.form-control::placeholder`,"rule-name":"color"}})],1)])],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Field Styles","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('sid-font',{attrs:{"prefix":"Field","sid":`${_vm.sidClass} .input.form-control`}}),_c('sid-range-slider',{attrs:{"label":"Field Font Size","sid":`${_vm.sidClass} .input.form-control`,"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Field Text Color")]),_c('sid-color',{attrs:{"sid":`${_vm.sidClass} .input.form-control`,"rule-name":"color"}})],1)])],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Background","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('sid-background',{attrs:{"sid":`${_vm.sidClass} .input.form-control`,"small":""}})],1)]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('sid-background',{attrs:{"sid":`${_vm.sidClass} .input.form-control`,"presudo":":hover","small":""}})],1)]},proxy:true}])})],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Border & Radius","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between !gap-[20px]"},[_c('label',{staticClass:"w-full pb-0"},[_vm._v("Border Type")]),_c('sid-select',{attrs:{"sid":`${_vm.sidClass} .input.form-control`,"rule-name":"border-style","searchable":false,"options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`${_vm.sidClass} .input.form-control`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`${_vm.sidClass} .input.form-control`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`${_vm.sidClass} .input.form-control`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`${_vm.sidClass} .input.form-control`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`${_vm.sidClass} .input.form-control`,"label":"Border Width","rule-name":"border","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`${_vm.sidClass} .input.form-control`,"rule-name":"border-color","presudo":":hover"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`${_vm.sidClass} .input.form-control`,"rule-name":"border","presudo":":hover","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":!_vm.staticType ? 'Padding & Margins' : 'Padding',"button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`${_vm.sidClass} .input.form-control`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),(!_vm.staticType)?_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.element.sid}--margin`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }